import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { hanscribeRoleLabel } from "src/libs/portal/hanscribe/hanscribe";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    private readonly sidebarStorageKey = 'hanscribe.sidebar.expanded';
    public railExpanded = false;
    public userMenuOpen = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.railExpanded = this.savedRailState();
        this.publishRailState();
        await this.service.render();
    }

    @HostListener('document:click')
    public async clickout() {
        await this.closeUserMenu();
    }

    @HostListener('document:keydown.escape')
    public async escapeMenu() {
        await this.closeUserMenu();
    }

    public stopMenuEvent(event?: Event) {
        if (event) event.stopPropagation();
    }

    public async toggleRail(event?: Event) {
        this.stopMenuEvent(event);
        this.railExpanded = !this.railExpanded;
        this.userMenuOpen = false;
        try {
            localStorage.setItem(this.sidebarStorageKey, this.railExpanded ? '1' : '0');
        } catch (e) { }
        this.publishRailState();
        await this.service.render();
    }

    public async toggleUserMenu(event?: Event) {
        this.stopMenuEvent(event);
        this.userMenuOpen = !this.userMenuOpen;
        await this.service.render();
    }

    public async closeUserMenu(event?: Event) {
        this.stopMenuEvent(event);
        if (!this.userMenuOpen) return;
        this.userMenuOpen = false;
        await this.service.render();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public sidebarClass() {
        const width = this.railExpanded ? 'lg:w-56' : 'lg:w-[72px]';
        return `relative flex h-full min-h-0 w-full flex-col overflow-visible border-r border-[#dedbd2] bg-[#fbfaf6] transition-[width] duration-200 ease-out ${width}`;
    }

    public brandHeaderClass() {
        return 'flex w-full items-center justify-center';
    }

    public brandLinkClass() {
        const desktop = this.railExpanded ? 'lg:flex-1 lg:justify-start' : 'lg:flex-none lg:justify-center';
        return `flex min-w-0 items-center gap-3 rounded-[6px] focus:outline-none focus:ring-2 focus:ring-[#c69a31] focus:ring-offset-2 ${desktop}`;
    }

    public brandTextClass() {
        return this.railExpanded ? 'min-w-0 leading-tight' : 'min-w-0 leading-tight lg:hidden';
    }

    public railToggleClass() {
        return 'absolute -right-6 top-24 z-50 hidden h-10 w-6 items-center justify-center rounded-r-[6px] border border-l-0 border-[#cbc9c0] bg-[#fbfaf6] text-[#66706b] transition-colors hover:bg-[#edf1ee] hover:text-[#17483e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#c69a31] focus-visible:ring-offset-1 lg:flex';
    }

    public sectionLabelClass() {
        const desktop = this.railExpanded ? '' : 'lg:sr-only';
        return `px-2 text-[10px] font-bold uppercase tracking-[0.12em] text-[#7a827e] ${desktop}`;
    }

    public navItemClass(link: string) {
        const base = 'group relative flex min-h-11 items-center gap-3 rounded-[6px] text-[13px] font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[#c69a31] focus:ring-offset-2';
        const spacing = this.railExpanded ? 'justify-start px-3 py-2' : 'justify-start px-3 py-2 lg:justify-center lg:px-0';
        if (this.isActive(link)) {
            return `${base} ${spacing} bg-[#e7ede9] text-[#17483e]`;
        }
        return `${base} ${spacing} text-[#626b66] hover:bg-[#f0eee7] hover:text-[#17483e]`;
    }

    public navLabelClass() {
        const base = 'min-w-0 flex-1 truncate';
        if (this.railExpanded) return base;
        return `${base} lg:pointer-events-none lg:absolute lg:left-[calc(100%+0.75rem)] lg:top-1/2 lg:z-50 lg:w-max lg:max-w-56 lg:-translate-y-1/2 lg:rounded-[6px] lg:border lg:border-[#dedbd2] lg:bg-[#fbfaf6] lg:px-2.5 lg:py-1.5 lg:text-[12px] lg:font-semibold lg:text-[#303934] lg:opacity-0 lg:shadow-lg lg:transition-opacity lg:group-hover:opacity-100 lg:group-focus-within:opacity-100`;
    }

    public activeIndicatorClass() {
        return 'absolute -left-3 top-2 bottom-2 w-0.5 rounded-r-full bg-[#17483e]';
    }

    public userMenuClass() {
        const desktop = this.railExpanded ? 'lg:left-3 lg:right-3 lg:w-auto' : 'lg:left-3 lg:right-auto lg:w-64';
        return `absolute bottom-full left-3 right-3 z-50 mb-2 overflow-hidden rounded-[8px] border border-[#dedbd2] bg-[#fbfaf6] shadow-[0_18px_45px_rgba(29,36,33,0.14)] ${desktop}`;
    }

    public userButtonClass() {
        const desktop = this.railExpanded ? 'lg:justify-start lg:px-3' : 'lg:justify-center lg:px-0';
        return `flex min-h-11 w-full items-center gap-3 rounded-[6px] bg-transparent px-3 py-2 text-left transition-colors hover:bg-[#edf1ee] focus:outline-none focus:ring-2 focus:ring-[#c69a31] focus:ring-offset-2 ${desktop}`;
    }

    public userTextClass() {
        return this.railExpanded ? 'min-w-0 flex-1 leading-tight' : 'min-w-0 flex-1 leading-tight lg:hidden';
    }

    public userChevronClass() {
        return this.railExpanded ? 'size-4 shrink-0 text-slate-400' : 'size-4 shrink-0 text-slate-400 lg:hidden';
    }

    public sessionInitial() {
        const name = String(this.service.auth.session?.name || this.service.auth.session?.email || 'H').trim();
        return name.charAt(0).toUpperCase() || 'H';
    }

    public sessionName() {
        return this.service.auth.session?.name || 'Hanscribe 사용자';
    }

    public sessionAccount() {
        const session = this.service.auth.session || {};
        return session.email || session.id || '계정 정보 없음';
    }

    public sessionRoleLabel() {
        return this.roleLabel(this.service.auth.session?.role || 'user');
    }

    public sessionOrganization() {
        const session = this.service.auth.session || {};
        return session.organization || 'Hanscribe Clinic';
    }

    public isAdmin() {
        return this.service.auth.session?.role === 'admin';
    }

    public roleLabel(role: string) {
        return hanscribeRoleLabel(role);
    }

    public railToggleLabel() {
        return this.railExpanded ? '사이드바 접기' : '사이드바 펼치기';
    }

    private savedRailState() {
        try {
            return localStorage.getItem(this.sidebarStorageKey) === '1';
        } catch (e) {
            return false;
        }
    }

    private publishRailState() {
        try {
            window.dispatchEvent(new CustomEvent('hanscribe-sidebar-state', {
                detail: { expanded: this.railExpanded }
            }));
        } catch (e) { }
    }
}

export default ComponentNavSidebarComponent;